import React from 'react';

import { compose } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import ContentLoader from 'react-content-loader';
import { injectIntl } from 'react-intl';
import { withTheme } from '@material-ui/core/styles';
import findicon1 from 'assets/images/hci1.png';
import { withRouter } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import HOCSectionLoader from '../HOC/HOCSectionLoader';
import { Fade, DialogContent, Dialog } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import NewServiceSuggestionDialog from '../Dialogs/NewServiceSuggestionDialog';
import LoginDialog from '../Dialogs/LoginDialog';
import { Minimize, Add, Remove, Clear } from '@material-ui/icons';

var isMounted = false;

var addedTask = null;

const container = {
    paddingRight: '15px',
    paddingLeft: '15px',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '100%',
    '@media (min-width: 576px)': {
        maxWidth: '540px'
    },
    '@media (min-width: 768px)': {
        maxWidth: '750px'
    },
    '@media (min-width: 992px)': {
        maxWidth: '970px'
    },
    '@media (min-width: 1200px)': {
        maxWidth: '1170px'
    }
};

class FindYourService extends React.Component {
    state = {
        expanded: false,
        clickValue: false,
        itemId: '',
        markedFav: 0,
        serviceList: [],
        loader: false,
        showServiceDialog: false,
        selectedServiceId: "",
        service_type: "",
        newServiceDialog: false,
        showLoginModal: false,
        evenSingleAdded: 0,
        showBookButton: false

    };
    componentDidMount() {
        isMounted = true;

        this.getData();
    }
    componentWillUnmount() {
        isMounted = false;
    }
    getData = () => {
        if (isMounted) {
            this.setState({ loader: true });
            this.props.serviceListAction(this.onDone);
        }
    };
    onDone = (success, data) => {

        this.setState({ loader: false });
        if (success) {
            var tasksArray = data.data.map(taskItem => {
                taskItem.qty = 0
                return taskItem
            })
            this.setState({ serviceList: tasksArray });
        }
    };
    handleExpandClick = () => {
        this.setState(state => ({ expanded: !state.expanded }));
    };
    renderLoading = index => {
        return (
            <div className="col-xs-12" key={index}>
                <ContentLoader
                    height={300}
                    width={300}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="13" rx="2" ry="2" width="280" height="200" />
                    <circle cx="25" cy="250" r="15" />
                    <rect
                        x="50"
                        y="240"
                        rx="4"
                        ry="4"
                        width="100"
                        height="10"
                    />
                    <rect x="50" y="260" rx="3" ry="3" width="50" height="8" />
                    <rect x="10" y="290" rx="3" ry="3" width="200" height="8" />
                </ContentLoader>
            </div>
        );
    };
    renderImageLoading = () => {
        return (
            <div>
                <ContentLoader
                    height={250}
                    width={280}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="2" ry="2" width="280" height="250" />
                </ContentLoader>
            </div>
        );
    };
    actionCallbacks(action, res) {
        if (action === 'view') {
            this.props.providerSelected(res);
        }
    }
    renderAllService = () => {


        if (this.props.settings.constants.serviceAssignment == "user") {
            this.props.history.push(`/category/services`);
        } else {
            this.setState({
                showServiceDialog: true,
            })
        }
    };
    handleClick = service => {
        console.log("servicesss:::", service)
        /*  if (this.props.settings.constants.serviceAssignment == "user") {
             this.props.history.push({ pathname: `/provider/list/${service.slug}` });
         } else {
             this.props.history.push({
                 pathname: `/book/service/2912adarsh1245/${service.key}`,
                 state: { serviceDataSource:}
             });
         } */
        this.setState({
            serviceList: [service]
        }, () => {
            console.log("Service List source:::", this.state.serviceList)
            this.setState({
                showServiceDialog: true
            })

        })

    };

    handleCloseServiceDialog = () => {
        this.setState({
            showServiceDialog: false,
            showBookButton: false
        }, () => {
            this.getData();
        })
    }

    onBookNow = () => {
        console.log("onBookNow:::::322222::::", this.props.userData)
        const bookingPopupOption = this.props.userData.name ? true : false;

        if (bookingPopupOption) {
            addedTask = null;
            if (this.state.serviceList.length < 0) {
                NotificationManager.error(
                    "You haven't add any service",
                    'Oops!'
                );
            } else {
                /* this.setState({
                    selectedServiceId: "",
                    service_type: ""
                }) */
                this.props.history.push({
                    pathname: `/book/service/2912adarsh1245`,
                    state: { serviceDataSource: this.state.serviceList }
                });
            }

        } else {
            this.setState({
                showLoginModal: true,
                showServiceDialog: false,
            })
            /* addedTask = null;
            this.setState({
                selectedServiceId: "",
                service_type: ""
            })
            this.props.history.push(`/user/signin`); */
        }
    };


    addServices = (index, serviceId, service_type) => {
        /* if (addedTask == index) {
            addedTask = null
            this.setState({
                selectedServiceId: "",
                service_type: ""
            })
        } else {
            addedTask = index;
            this.setState({
                selectedServiceId: serviceId,
                service_type: service_type
            })
        } */
        this.setState({
            selectedServiceId: serviceId,
            service_type: service_type
        }, () => { this.onBookNow() })
    }

    openNewServiceSuggestionDialog = () => {
        const bookingPopupOption = this.props.userData.name ? true : false;
        if (bookingPopupOption) {
            this.setState({
                newServiceDialog: true
            })
        } else {
            NotificationManager.error("Oops! please login to add suggestion")
        }
    }
    handleCloseSuggestionDialog = () => {
        this.setState({
            newServiceDialog: false,
            showBookButton: false,
        })
    }

    handleCloseLoginModal = () => {
        console.log("Close Login modal:::")
        this.setState({
            showLoginModal: false,
            showBookButton: false,
        }, () => {
            this.getData();
        })
    }


    increaseQty(item, index) {
        console.log("Itemmmmmm :::", item)
        // item.service_type == "Package" ? item.qty += 1 : item.qty = 1;
        item.service_type == "Package" &&  "Hourly" ? item.qty += 1 : item.qty += 1;
        let updatedTask = [...this.state.serviceList];
        updatedTask[index] = item;
        const checkServiceData = updatedTask.filter(singleItem => singleItem.qty > 0);
        if (checkServiceData.length > 0) {
            this.setState({ serviceList: updatedTask, showBookButton: true });
        } else {
            this.setState({ serviceList: updatedTask, showBookButton: false });
        }
    }

    decreaseQty(item, index) {
        item.qty -= 1;
        let updatedTask = [...this.state.serviceList];
        updatedTask[index] = item;
        const checkServiceData = updatedTask.filter(singleItem => singleItem.qty > 0);
        if (checkServiceData.length > 0) {
            this.setState({ serviceList: updatedTask, showBookButton: true });
        } else {
            this.setState({ serviceList: updatedTask, showBookButton: false });
        }
    }


    render() {
        const { serviceList, loader } = this.state;

        const { formatMessage } = this.props.intl;
        return (
            <div className="com-padd com-padd-redu-bot1 pad-bot-red-40" style={{ paddingBottom: 50 }}>
                <div className="container">
                    <div>
                        <div className="col-md-12" style={{}}>
                            {/* <HOCSectionLoader loading={loader}>
 */}

                            {/*  <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", marginBottom: "1rem" }}>

                                    <div className="col-md-7">
                                        <div className="icon-text">
                                            <div class="test1">
                                                <h3 style={{ fontFamily: "sans-serif" }}>Find trusted professionals for your home maintenance.</h3>
                                            </div>
                                            <div class="icon">
                                                <img style={{ verticalAlign: "middle", borderStyle: "none" }} src={require("../../assets/icon/inspection/black.png")} class="img-fluid" alt="img" />
                                                <img style={{ verticalAlign: "middle", borderStyle: "none" }}
                                                    src={require("../../assets/icon/roof/black.png")} class="img-fluid" alt="img" />
                                                <img style={{ verticalAlign: "middle", borderStyle: "none" }}
                                                    src={require("../../assets/icon/electrician/black.png")} class="img-fluid" alt="img" />
                                                <img style={{ verticalAlign: "middle", borderStyle: "none" }}
                                                    src={require("../../assets/icon/heater/black.png")} class="img-fluid" alt="img" />
                                                <img style={{ verticalAlign: "middle", borderStyle: "none" }}
                                                    src={require("../../assets/icon/exterminator/black.png")} class="img-fluid" alt="img" />
                                                <img style={{ verticalAlign: "middle", borderStyle: "none" }}
                                                    src={require("../../assets/icon/handy man/black.png")} class="img-fluid" alt="img" />
                                                <img style={{ verticalAlign: "middle", borderStyle: "none" }}
                                                    src={require("../../assets/icon/plumber/black.png")} class="img-fluid" alt="img" />
                                                <img style={{ verticalAlign: "middle", borderStyle: "none" }}
                                                    src={require("../../assets/icon/landscaping/black.png")} class="img-fluid" alt="img" />
                                                <img style={{ verticalAlign: "middle", borderStyle: "none" }}
                                                    src={require("../../assets/icon/repair/black.png")} class="img-fluid" alt="img" />
                                                <img style={{ verticalAlign: "middle", borderStyle: "none" }}
                                                    src={require("../../assets/icon/pool/black.png")} class="img-fluid" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-5">
                                        <div className="img1">
                                            <img style={{ verticalAlign: "middle", borderStyle: "none" }} src={require("../../assets/images/Mask Group11 (1).png")} class="img-fluid" />
                                        </div>

                                    </div>
                                </div>
 */}


                            {/* </HOCSectionLoader> */}
                        </div>
                    </div>
                    <div>
                        <div className="text-center col-12 com-title">
                            <h1 style={{
                                fontWeight: "500", fontFamily: "Avenir", color: "#000000", marginBottom: "1.5rem",
                                fontSize: "2.5rem"
                            }}>Popular Servers</h1>
                            <p style={{ fontSize: 20, color: "#000000" }}>
                                Book a qualified pro for your Home Wihout Making a call
                            </p>
                        </div>
                        <div className="col-md-12">
                            <HOCSectionLoader loading={loader}>

                                <div className="img-div" style={{
                                    display: "flex", flexDirection: "row", flexWrap: "wrap", marginBottom: "1rem", /* justifyContent: "center" */
                                    paddingLeft: 50, paddingRight: 50
                                }}>

                                    {serviceList.length > 0 &&
                                        serviceList
                                            .slice(0, 6).map((service, index) => {
                                                return (
                                                    <div style={{
                                                        cursor:
                                                            'pointer'
                                                    }}
                                                        onClick={() =>
                                                            this.handleClick(
                                                                service
                                                            )
                                                        }
                                                        style={{ display: "block", margin: "15px 22px" }}>
                                                        <img className="img1" style={{
                                                            boxShadow: "2px 21px 25px #ccc", verticalAlign: "middle", borderStyle: "none",
                                                           /*  width: 288, height: 166,  */borderRadius: 25
                                                        }}
                                                            src={service
                                                                .image
                                                                .medium} />
                                                        <h4 style={{
                                                            paddingTop: 20, fontWeight: "bold", marginBottom: ".5rem", fontSize: "1.5rem",
                                                            fontFamily: "Avenir", color: "#000000"
                                                        }}>{
                                                                service.heading
                                                            }</h4>
                                                        <p style={{ color: "#000000", fontSize: 16 }}>34 pros</p>
                                                    </div>)
                                            })
                                    }
                                </div>
                                <div className="text-center" style={{ marginTop: "2rem" }}>
                                    <a> <h5
                                        onClick={this.renderAllService}
                                        className="dir-ho-cat"
                                    >
                                        <span style={{ color: "#0078ff", borderBottom: "2px solid #0078ff", fontSize: 20, fontWeight: "200" }}>
                                            View All Services
                                        </span>
                                    </h5>
                                    </a>
                                </div>

                            </HOCSectionLoader>
                        </div>
                    </div>


                    <Dialog
                        fullWidth={true}
                        TransitionComponent={Fade}
                        disableBackdropClick={false}
                        className="service-modal"
                        open={this.state.showServiceDialog}
                        onClose={this.handleCloseServiceDialog}
                        aria-labelledby="form-dialog-title"
                    >

                        <div className="modal-header dir-pop-head"
                            style={{ height: 60, display: "flex", justifyContent: "space-between", width: "100%" }}>
                            <h4 style={{ alignSelf: "center" }}>Tasks</h4>
                            <Clear style={{ alignSelf: "center", color: "#ffffff" }} onClick={() => {
                                this.handleCloseServiceDialog()
                            }} />

                        </div>

                        <div style={{ overflowY: "scroll" }}>
                            <DialogContent>
                                {serviceList.length > 0 && serviceList.map((item, index) => {

                                    return (

                                        <div className="service-modal-li">
                                            <div className="row align-items-center" >
                                                <div className="col-md-9 text-left modal-list">
                                                    <h4>{item.heading}</h4>
                                                    <p>{item.description}</p>
                                                    <p>{item.service_type}</p>
                                                    {item.service_type != "Hourly" ? <p>{item.price}</p> : <p>{item.price}/hr</p>}

                                                </div>
                                                <div className="col-md-3 text-right d-flex" style={{ flexDirection: "row", borderRadius: 3 }}>


                                                    {item.qty == 0 ?
                                                        <div className="col-md-12 d-flex" style={{ flexDirection: "row" }}>
                                                            <div className="col-md-8 justify-content-center d-flex">
                                                                <p style={{ alignSelf: "center" }}>Add</p>
                                                            </div>
                                                            <div className="col-md-4 justify-content-center d-flex" onClick={() => this.increaseQty(item, index)}
                                                                style={{ backgroundColor: this.props.colors.SECONDARY.HEX }}>
                                                                <Add style={{ alignSelf: "center" }} />
                                                            </div>
                                                        </div> :

                                                        <div className="col-md-12 d-flex" style={{ flexDirection: "row" }}>
                                                            <div className="col-md-4 justify-content-center d-flex" onClick={() => this.decreaseQty(item, index)}
                                                                style={{ backgroundColor: this.props.colors.SECONDARY.HEX }}>
                                                                <Remove style={{ alignSelf: "center" }} />
                                                            </div>
                                                            <div className="col-md-4 justify-content-center d-flex">
                                                                <p style={{ alignSelf: "center" }}>{item.qty}</p>
                                                            </div>
                                                            <div className="col-md-4 justify-content-center d-flex" onClick={() => this.increaseQty(item, index)}
                                                                style={{ backgroundColor: this.props.colors.SECONDARY.HEX }}>
                                                                <Add style={{ alignSelf: "center" }} />
                                                            </div>
                                                        </div>}
                                                    {/* <Button
                                                        className="btn-primary-new"
                                                        variant="contained"
                                                        color={addedTask === index ? "secondary" : "primary"}
                                                        onClick={() => { this.addServices(index, item.key, item.service_type) }}
                                                    >
                                                        <label style={{ color: "#ffffff", fontSize: 14 }}>{/* {addedTask === index ? "Remove" : "Add"}Book</label>
                                                    </Button> */}
                                                    {/* <button style={{
                                                    alignSelf: 'center', display: "inline-flex",
                                                    position: "absolute", bottom: 5, justifyContent: "center"
                                                }}
                                                    className="waves-effect waves-light btn-large"
                                                    disabled={this.state.serviceData.length == 0 || addedTask == null ? true : false}
                                                    onClick={this.onBookNow}
                                                >Book Now</button> */}

                                                </div>

                                            </div>
                                        </div>
                                    )
                                })}
                                {this.state.serviceList.length == 0 ?
                                    <div className="service-modal-li">
                                        <div className="row align-items-center">
                                            <div className="col-md-7 text-left modal-list">
                                                <h4>No service availabe in this category</h4>

                                            </div>
                                        </div>
                                    </div> : null

                                }

                                {this.state.serviceList.length == 0 &&
                                    <div className="md-12 justify-content-center d-flex">
                                        <button type="button" className="custom-button"
                                            onClick={() => {
                                                this.openNewServiceSuggestionDialog()
                                            }}>NEW SERVICE SUGGESTION</button>
                                    </div>}

                            </DialogContent>
                        </div>


                        {this.state.showBookButton && <button style={{
                            alignSelf: 'center', display: "inline-flex",
                            position: "unset", bottom: 10, justifyContent: "center",
                            backgroundColor: this.props.colors.SECONDARY.HEX, padding: 15, borderRadius: 8,
                            color: "#ffffff", borderWidth: 0, width: "90%" , marginBottom: 15
                        }}
                            disabled={this.state.showBookButton ? false : true}
                            onClick={this.onBookNow}
                        >BOOK NOW</button>}

                        {this.state.newServiceDialog &&
                            <NewServiceSuggestionDialog
                                closeDialog={this.handleCloseSuggestionDialog}
                            />}

                    </Dialog>

                    {this.state.showLoginModal &&
                        <LoginDialog
                            showLoginModal={this.state.showLoginModal}
                            selectedServiceId={this.state.selectedServiceId}
                            service_type={this.state.service_type}
                            closeLoginModal={this.handleCloseLoginModal}
                            serviceDataSource={this.state.serviceList}
                        />}
                </div>
            </div >
        );
    }
}


const mapStateToProps = ({ settings, auth }) => {
    return {
        settings: settings,
        userData: auth.userData,
        colors: settings.colors
    };
};
const composedComponent = compose(
    withTheme(),

    connect(mapStateToProps, actions)
);
export default composedComponent(injectIntl(withRouter(FindYourService)));



// WEBPACK FOOTER //
// ./src/components/Providers/FindYourService.js